import '../../style/index.less';



// WEBPACK FOOTER //
// ./_antd1.11.2/icon/style/index.js